import ToggleMode from './ToggleMode';

export default {
  __init__: [
    'toggleMode'
  ],
  toggleMode: [ 'type', ToggleMode ]
};